module.exports = __webpack_public_path__ + "static/favicon-98b1db9f942abec34fde9b9d8eaf5c7a.ico";